import Register from "./RegisterContainer";

export default Register;
